import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const solicitudImporterSelectors = importerSelectors(
  'solicitud.importer',
);

export default solicitudImporterSelectors;
